import { meCreateCheckHandler } from '~/modules/SDK/me/meCreateCheckHandler';
export const meCheckHandlerHasMe = meCreateCheckHandler(scope => {
    return !!scope.meUserState?.uid;
});
